import { Center, Spinner } from '@chakra-ui/react';
import useQueryParam from 'hooks/shared/useQueryParam';
import PrivateChannelDetailArticleCard from 'presentation/components/modules/articles/PrivateChannelDetailArticleCard';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchArticleDetailQuery } from 'rtkQuery/sharespro/queries/articles';

const PrivateChannelDetailCardContainer: FC = () => {
  const { id } = useParams();

  const { data, isFetching, error, refetch } = useFetchArticleDetailQuery(
    +(id as string)
  );

  const [color] = useQueryParam<string>('color', {
    ifAbsent: '#210061',
    provider: (val) => val,
  });

  let content;
  if (data) {
    content = <PrivateChannelDetailArticleCard article={data} color={color} page={1}/>;
  } else if (isFetching) {
    content = (
      <Center>
        <Spinner />
      </Center>
    );
  } else if (error) {
    content = (
      <AppCard p="20">
        <Center>
          <ErrorContainer
            error={error}
            onRetry={() => {
              refetch();
            }}
          />
        </Center>
      </AppCard>
    );
  } else {
    content = (
      <Center>
        <Spinner />
      </Center>
    );
  }

  return content;
};

export default PrivateChannelDetailCardContainer;
